import baraneh from './baraneh'

export default {
  name: 'External',
  path: 'external',
  meta: {
    label: 'external',
    auth: 'external'
  },
  component: {
    name: 'External',
    render(c) {
      return c('router-view')
    }
  },
  children: [baraneh]
}
